import {
  GENERATOR,
  MAP_SIZE_MAX,
  FEATURE_TIERS,
  FEATURE_KEYS,
} from "./constants";

export const getMapSizeMax = (panelState) => {
  switch (panelState.generator) {
    case GENERATOR.DUNGEON:
      return MAP_SIZE_MAX[panelState.visuals.theme] || 16;
    case GENERATOR.ROAD:
      return 9;
    case GENERATOR.WILDERNESS:
      // Four size classes, banded 2-9 by MapSize. The Custom slider is not
      // offered for wilderness, so this only bounds the value defensively.
      return 9;
    default:
      return 16;
  }
};

export const getFeatureSetting = (featureKey, tier) => {
  return FEATURE_TIERS[featureKey] &&
    FEATURE_TIERS[featureKey][tier] !== undefined
    ? FEATURE_TIERS[featureKey][tier]
    : null;
};

// A tier's value says what that tier gets, and the shape differs per feature:
// on/off features grade with booleans, features with a restricted option set
// grade with labels ("Any" for every option, otherwise the one allowed option,
// e.g. "Forest"). Either way, a tier fully unlocks the feature at `true` or
// "Any".
const isTierUnlocked = (value) => value === true || value === "Any";

export const getFirstAvailableTier = (featureKey) => {
  if (!FEATURE_TIERS[featureKey]) return "Patreon";

  const tierValues = Object.entries(FEATURE_TIERS[featureKey]);
  const firstAvailable = tierValues.find(([tier, value]) =>
    isTierUnlocked(value)
  );

  // Features graded on a scale we can't read (theme lists, history counts).
  if (!firstAvailable) return "Patreon";

  return firstAvailable[0];
};

export const isAllThemeOptionsDisabled = (options, userTier) =>
  options === undefined
    ? false
    : options.every(
        (option) =>
          !FEATURE_TIERS[FEATURE_KEYS[GENERATOR.DUNGEON].AVAILABLE_THEMES][
            userTier
          ].includes(option)
      );

// The wilderness "Type" feature tier setting is either "Any" (all types) or a
// single allowed type label like "Forest". A type is enabled when the tier
// allows any type, or the allowed label matches this type's value.
export const isWildernessTypeEnabled = (typeValue, tierSetting) =>
  tierSetting === "Any" || String(tierSetting).toLowerCase() === typeValue;
